// extracted by mini-css-extract-plugin
module.exports = {"header":"ShipmentList_header__CQXNf","title":"ShipmentList_title__3HjxG","small":"ShipmentList_small__oFjdX","btnContainer":"ShipmentList_btnContainer__21en2"};